import { TestTypeValue } from '../test-list/types';

export const REFLECTOR_TYPE = {
  LIGHT: 'LightReflector',
  FULL: 'FullReflector'
};

export const testConfigs = [
  {
    testType: TestTypeValue.TWAMP,
    capabilities: 'twamp-initiator',
    maxconcurrent: 'max-concurrent-tests',
    operationalState: 'running',
    testQueueStatusName: 'twamp'
  },
  {
    testType: TestTypeValue.TWAMP_REFLECTOR,
    capabilities: 'twamp-reflector',
    maxconcurrent: 'max-concurrent-tests',
    operationalState: 'running',
    testQueueStatusName: REFLECTOR_TYPE.FULL
  },
  {
    testType: TestTypeValue.TWAMP_LIGHT_REFLECTOR,
    capabilities: 'twamp-light-reflector',
    maxconcurrent: 'max-concurrent-tests',
    operationalState: 'running',
    testQueueStatusName: REFLECTOR_TYPE.LIGHT
  },
  {
    testType: TestTypeValue.SERVICE_CONTINUITY,
    capabilities: 'servicecontinuity',
    maxconcurrent: 'max-concurrent-tests',
    operationalState: 'running',
    testQueueStatusName: 'service'
  },
  {
    testType: TestTypeValue.VOIP,
    capabilities: 'voip',
    maxconcurrent: 'max-concurrent-tests',
    operationalState: 'running',
    testQueueStatusName: 'voip',
    defaultMaxConcurrent: 1
  },
  {
    testType: TestTypeValue.TRUESPEED,
    capabilities: 'truespeed',
    maxconcurrent: 'max-concurrent-tests',
    operationalState: 'running',
    testQueueStatusName: 'truespeed'
  },
  {
    testType: TestTypeValue.MULTISTEP,
    capabilities: 'multistep',
    maxconcurrent: 'max-concurrent-tests',
    operationalState: 'running',
    testQueueStatusName: 'multistep'
  },
  {
    testType: TestTypeValue.Y1564,
    capabilities: 'y1564',
    maxconcurrent: 'max-concurrent-tests',
    operationalState: 'running',
    testQueueStatusName: 'y1564'
  },
  {
    testType: TestTypeValue.BERT,
    capabilities: 'bert',
    maxconcurrent: 'max-concurrent-tests',
    operationalState: 'running',
    testQueueStatusName: 'bert'
  },
  {
    testType: TestTypeValue.Y1731,
    capabilities: 'y1731-initiator',
    maxconcurrent: 'max-concurrent-tests',
    operationalState: 'running',
    testQueueStatusName: 'y1731'
  },
  {
    testType: TestTypeValue.RFC2544,
    capabilities: 'rfc2544',
    maxconcurrent: 'max-concurrent-tests',
    operationalState: 'running',
    testQueueStatusName: 'rfc2544'
  },
  {
    testType: TestTypeValue.UDP,
    capabilities: 'udp',
    maxconcurrent: 'max-concurrent-tests',
    operationalState: 'running',
    testQueueStatusName: 'udp'
  },
  {
    testType: TestTypeValue.HTTP,
    capabilities: 'http',
    maxconcurrent: 'max-concurrent-tests',
    operationalState: 'running',
    testQueueStatusName: 'http'
  },
  {
    testType: TestTypeValue.FTP,
    capabilities: 'ftp',
    maxconcurrent: 'max-concurrent-tests',
    operationalState: 'running',
    testQueueStatusName: 'ftp'
  }
];
